export const MY_COURSES_TAB_KEYS = {
  ALL: 'all',
  NEW: 'new',
  CREATED: 'created',
  PAYED: 'payed',
  FINISHED: 'finished',
} as const;

export type MyCoursesTabKey =
  (typeof MY_COURSES_TAB_KEYS)[keyof typeof MY_COURSES_TAB_KEYS];

export const MY_COURSES_TABS: { key: MyCoursesTabKey; label: string }[] = [
  { key: MY_COURSES_TAB_KEYS.ALL, label: 'Все' },
  { key: MY_COURSES_TAB_KEYS.NEW, label: 'Новые' },
  { key: MY_COURSES_TAB_KEYS.CREATED, label: 'Созданные' },
  { key: MY_COURSES_TAB_KEYS.PAYED, label: 'Оплаченные' },
  { key: MY_COURSES_TAB_KEYS.FINISHED, label: 'Завершенные' },
];

export const MY_COURSES_TAB_PARAM = 'tab';
